import React, { useState } from 'react'
import styled from 'styled-components'
import { useBorderoSetores } from '../../hooks/bordero'

const fmtInt = (n: number) => Math.round(Number(n) || 0).toLocaleString('pt-BR')
const fmtBRL = (n: number) =>
  'R$ ' + (Number(n) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

const Wrap = styled.div`
  border: 1px solid #E0E0E0;
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
`
const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(220px, 1fr) 90px 90px 130px;
  align-items: center;
  font-variant-numeric: tabular-nums;
  > span:not(.name) {
    text-align: right;
    padding-right: 12px;
  }
`
const HeadRow = styled(Grid)`
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #98a2b3;
  padding: 8px 12px;
  border-bottom: 1px solid #E0E0E0;
  background: #F9F9F9;
  .name {
    padding-left: 4px;
  }
`
const SetorRow = styled(Grid)`
  font-size: 12.5px;
  color: #212121;
  font-weight: 600;
  padding: 8px 12px;
  border-bottom: 1px solid #EDEDED;
  cursor: pointer;
  &:hover {
    background: #F9F9F9;
  }
  .name {
    display: flex;
    align-items: center;
    gap: 6px;
  }
`
const IngRow = styled(Grid)`
  font-size: 12px;
  color: #616161;
  padding: 6px 12px 6px 30px;
  border-bottom: 1px solid #F5F5F5;
  background: #FCFCFC;
`
const Muted = styled.div`
  font-size: 12.5px;
  color: #98a2b3;
  padding: 12px;
`
const Caret = styled.span`
  color: #B0020B;
  font-size: 10px;
  width: 12px;
`

const tipoLabel = (t: string) => (t === 'M' ? ' · meia' : t === 'I' ? ' · inteira' : '')

interface Props {
  eventId: number
  startDate?: string
  endDate?: string
  pdvIds?: number[]
  ignorePracaTestes?: boolean
}

const SetorDrill: React.FC<Props> = ({ eventId, startDate, endDate, pdvIds, ignorePracaTestes }) => {
  const { setores, setoresLoading } = useBorderoSetores(eventId, {
    startDate,
    endDate,
    pdvIds,
    ignorePracaTestes,
  })
  const [open, setOpen] = useState<Record<number, boolean>>({})

  if (setoresLoading) return <Muted>Carregando setores…</Muted>
  if (!setores.length) return <Muted>Sem vendas por setor para os filtros.</Muted>

  return (
    <Wrap>
      <HeadRow>
        <span className="name">Setor / ingresso</span>
        <span>Pagos</span>
        <span>Cortesias</span>
        <span>Valor de face</span>
      </HeadRow>
      {setores.map((s) => (
        <React.Fragment key={s.setorId}>
          <SetorRow onClick={() => setOpen((o) => ({ ...o, [s.setorId]: !o[s.setorId] }))}>
            <span className="name">
              <Caret>{open[s.setorId] ? '▾' : '▸'}</Caret>
              {s.setor || 'Sem setor'}
            </span>
            <span>{fmtInt(s.pagos)}</span>
            <span>{fmtInt(s.cortesias)}</span>
            <span>{fmtBRL(s.valorFace)}</span>
          </SetorRow>
          {open[s.setorId] &&
            s.ingressos.map((i) => (
              <IngRow key={i.ingressoId}>
                <span className="name">
                  {i.nome}
                  {tipoLabel(i.tipo)}
                </span>
                <span>{fmtInt(i.pagos)}</span>
                <span>{fmtInt(i.cortesias)}</span>
                <span>{fmtBRL(i.valorFace)}</span>
              </IngRow>
            ))}
        </React.Fragment>
      ))}
    </Wrap>
  )
}

export default SetorDrill
